import { render, staticRenderFns } from "./productCell.vue?vue&type=template&id=49b51fda&scoped=true"
import script from "./productCell.vue?vue&type=script&lang=js"
export * from "./productCell.vue?vue&type=script&lang=js"
import style0 from "./productCell.vue?vue&type=style&index=0&id=49b51fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b51fda",
  null
  
)

export default component.exports